import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import BlockIconSVG from "../../svg/BlockIconSVG";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { useAppDispatch } from "../../../../custom-hooks/useAppDispatch";
import { UserServiceImpl } from "../../../../services/UserServiceImpl";
import { useNavigate } from "react-router-dom";

interface BlockButtonProps {
    userId: string;
    isBlocked: boolean;
}

const BlockButton: FC<BlockButtonProps> = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const blockUserProfile = async () => {
        const result = await dispatch(UserServiceImpl.blockUserThunk({ userId: props.userId }));
        if (result.meta.requestStatus === "fulfilled") {
            navigate(0);
        }
    };
    const unblockUserProfile = async () => {
        const result = await dispatch(UserServiceImpl.unblockUserThunk({ userId: props.userId }));
        if (result.meta.requestStatus === "fulfilled") {
            navigate(0);
        }
    };

    const actionHandler = props.isBlocked ? unblockUserProfile : blockUserProfile;
    const actionText = props.isBlocked ? t("userProfile.unblock") : t("userProfile.block");
    const assuranceText = props.isBlocked ? t("userProfile.unblockingAssurance") : t("userProfile.blockingAssurance");

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            confirmHandler={actionHandler}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelTitle={t("common.no")}
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={
                <div
                    className="flex items-center tmax4:mr-5 mt-3 cursor-pointer group"
                    onClick={() => setIsVisible(true)}
                >
                    <BlockIconSVG className="w-[32px] dmax2:w-[24px] mr-2 dmax2:mr-1 text-textFaded group-hover:text-textWhite transition duration-300" />
                    <span className="H14 dmax2:H14B text-textFaded group-hover:text-textWhite transition duration-300">
                        {actionText}
                    </span>
                </div>
            }
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                {assuranceText}
            </p>
        </CustomPopup>
    );
};

export default BlockButton;
